<template>
  <div class="etab-families-component">
    <ExtraBtnSquare
      v-for="family in sortedFamilies"
      :key="family.getId()"
      :icon="family.getIcon()"
      :active="isFamilySelected(family.getId())"
      :label="$t(family.getLabel())"
      @click="$emit('onSelect', family)"
    />
  </div>
</template>
<script>
  export default {
    props: {
      families: {
        type: Array,
        default: () => [],
      },
      selectedFamilyId: {
        type: Number,
        default: null,
      },
    },
    emits: ["onSelect"],
    computed: {
      sortedFamilies() {
        return [...this.families].sort((a, b) => a.getOrder() - b.getOrder());
      },
    },
    methods: {
      isFamilySelected(id) {
        return this.selectedFamilyId === id;
      },
    },
  };
</script>

<style lang="scss">
  .etab-families-component {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    button {
      flex: 0 0 140px;
      margin: 10px;

      @media screen and (max-width: 320px) {
        margin: 2px;
      }
    }
  }
</style>
